import Tooltip, {TooltipProps} from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';

interface InfoTooltipProps {
  position: TooltipProps["placement"],
  helpText: string | Array<string>
}

export const InfoTooltip = (props: InfoTooltipProps) => {

  return (
        <span className='info-tooltip'>
          <Tooltip id={`tooltip-${props.position}`}
          placement={props.position}
            children={<InfoIcon color='info' fontSize='small'/>}
            title={Array.isArray(props.helpText) ?
              <ul>
                {props.helpText.map(help => <li key={help}>{help}</li>)}
              </ul>
              : props.helpText}
          />
        </span>
    )
}